export default function providesTags({ type, result }) {
  return Array.isArray(result) && result?.length
    ? [...result.map(({ _id: id }) => ({ type, id }))]
    : result?._id
    ? [{ type, id: result._id }]
    : [type];
}
